// extracted by mini-css-extract-plugin
module.exports = {"error-boundary":"error-boundary-33cCIGSnaPLnOcEKSiPefz","errorBoundary":"error-boundary-33cCIGSnaPLnOcEKSiPefz","content":"content-1rH1v2pSdgkwp_0hnQPPd_"};